// This file is auto-generated during build
export const version = {
  release: 'oak-checkin-site@262fae7'
};
